module.exports = __webpack_public_path__ + "img/great_wall.32196c3b.svg";